import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-error-dialog",
  imports: [],
  template: `
    @if (visible) {
      <div class="backdrop">
        <div class="dialog">
          <span class="close-icon" (click)="close()">&times;</span>
          <div class="img_wrapper">
            <img src="../../../assets/rexpay/error.png" />
          </div>
          <p class="text-dashboard-gray text__small">{{ message }}</p>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
      }
      .dialog {
        background: white;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        max-width: 300px;
        position: relative;
        text-align: center;
      }
      .close-icon {
        position: absolute;
        top: -23px;
        right: -2px;
        font-size: 20px;
        font-weight: bold;
        color: #f25b61;
        cursor: pointer;
      }
      .close-icon:hover {
        color: #e53935;
      }
      .img_wrapper {
        height: 50px;
        margin-bottom: 1rem;
      }

      img {
        height: 100%;
      }
    `,
  ],
})
export class ErrorDialogComponent {
  @Input() visible = false;
  @Input() message = "An error occurred";

  @Input() error = "Error";
  @Output() closed = new EventEmitter<void>();

  close() {
    this.visible = false;
    this.closed.emit();
  }
}
